export type RecorderState = 'idle' | 'recording' | 'saving';

class LocalRecorderService {
  private recorder: MediaRecorder | null = null;
  private chunks: Blob[] = [];
  private stateListeners = new Set<(s: RecorderState) => void>();
  private state: RecorderState = 'idle';

  start(stream: MediaStream): void {
    if (this.recorder) return;
    this.chunks = [];
    this.recorder = new MediaRecorder(stream, { mimeType: 'video/webm;codecs=vp9,opus' });
    this.recorder.ondataavailable = (e) => {
      if (e.data.size > 0) this.chunks.push(e.data);
    };
    this.recorder.onstop = () => {
      this.setState('saving');
      const blob = new Blob(this.chunks, { type: 'video/webm' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `stream-${new Date().toISOString().replace(/[:.]/g, '-')}.webm`;
      a.click();
      URL.revokeObjectURL(url);
      this.chunks = [];
      this.recorder = null;
      this.setState('idle');
    };
    this.recorder.start(1000); // chunk every 1s so we don't lose everything on crash
    this.setState('recording');
  }

  stop(): void {
    this.recorder?.stop();
  }

  getState(): RecorderState {
    return this.state;
  }

  onStateChanged(listener: (s: RecorderState) => void): () => void {
    this.stateListeners.add(listener);
    return () => this.stateListeners.delete(listener);
  }

  private setState(s: RecorderState): void {
    this.state = s;
    this.stateListeners.forEach((l) => l(s));
  }
}

export const localRecorderService = new LocalRecorderService();